import React from 'react';
import PropTypes from 'prop-types';

// @mui
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

// core
import { withLang } from '_core/hocs/withLang';
import { useCartContext } from '_core/contexts/Cart';
import { Price } from '_core/components/Price';
import { PriceMix } from '_core/components/PriceMix';

// style
import { usePaymentBriefStyle } from './paymentBriefStyle';

export const RawPaymentBrief = (props) => {
  const { delivery, getLangString: l } = props;

  const classes = usePaymentBriefStyle();
  const cart = useCartContext();
  const shopCurrencyId = cart.shopCurrency?.id || cart.currency.id;

  return (
    <div className={classes.root}>
      <Grid container={true} className={classes.row}>
        <Grid item={true} xs={12} sm={6}>
          <Typography variant="body2" className={classes.label}>
            {l('r.core.cart.total')}{' '}
            {l(
              ['r._.carttotal.label.goodscount', cart.query.length],
              cart.query.length
            )}
            :
          </Typography>
        </Grid>

        <Grid item={true} xs={12} sm={6}>
          <PriceMix
            item={{
              currency: shopCurrencyId,
              value: cart.query.price - cart.query.discount
            }}
          />
        </Grid>
      </Grid>

      {delivery != null ? (
        <Grid container={true} className={classes.row}>
          <Grid item={true} xs={12} sm={6}>
            <Typography variant="body2" className={classes.label}>
              {l('r.core.cartstep.delivery.price')}:
            </Typography>
          </Grid>

          <Grid item={true} xs={12} sm={6}>
            <Typography variant="body1">
              <Price
                value={delivery.cost.value}
                currency={delivery.cost.currency.id}
              />
            </Typography>
          </Grid>
        </Grid>
      ) : null}
    </div>
  );
};

RawPaymentBrief.defaultProps = {};

RawPaymentBrief.propTypes = {
  // self props
  delivery: PropTypes.object,

  // `withLang` HOC props
  langInfo: PropTypes.object,
  langStrings: PropTypes.object,
  getLangObject: PropTypes.func,
  getFirstLangString: PropTypes.func,
  getLangStringSet: PropTypes.func,
  getLangString: PropTypes.func.isRequired
};

export const PaymentBrief = withLang(RawPaymentBrief);
